/*
  Cortazu PDP (q123): no size preselected on the main product. Hyper checks the first available size;
  that made quick clickers order a size they never chose. On load (unless the URL names a variant)
  the size radios are unchecked, the add-to-cart button reads "Select a size", and a click without a
  size scrolls to the picker instead of adding. Choosing a size hands control back to Hyper as usual.
  Loaded from snippets/product-information-blocks.liquid (main product only).
*/
(function () {
  if (/[?&]variant=/.test(location.search)) return;
  var SIZE_NAMES = ['size', 'maat', 'größe', 'grösse', 'taille'];
  var lang = (document.documentElement.lang || 'en').slice(0, 2);
  var LABEL = { nl: 'Kies je maat', de: 'Größe wählen' }[lang] || 'Select a size';
  var HINT = { nl: 'Kies eerst je maat', de: 'Bitte zuerst eine Größe wählen' }[lang] || 'Please choose your size first';

  function init() {
    var info = document.querySelector('.product__info-container');
    if (!info) return;
    var selects = info.querySelector('variant-selects');
    if (!selects) return;
    var form = document.getElementById('product-form-' + selects.dataset.section);
    if (!form) return;
    var fieldset = null;
    selects.querySelectorAll('fieldset').forEach(function (fs) {
      var input = fs.querySelector('input[type=radio]');
      if (!fieldset && input && SIZE_NAMES.indexOf((input.dataset.optionName || '').toLowerCase()) > -1) fieldset = fs;
    });
    if (!fieldset || fieldset.querySelectorAll('input[type=radio]').length < 2) return;

    var radios = fieldset.querySelectorAll('input[type=radio]');
    radios.forEach(function (r) { r.checked = false; });
    var shown = fieldset.querySelector('[data-selected-swatch-value]');
    if (shown) shown.textContent = '';
    form.classList.add('cz-need-size');
    document.documentElement.classList.add('cz-need-size-page');
    document.dispatchEvent(new CustomEvent('cz:size-needed'));
    document.querySelectorAll('[data-cz-sticky-size-value]').forEach(function (el) { el.textContent = ''; });

    var btn = form.querySelector('[name="add"]');
    if (btn && !btn.querySelector('.cz-need-size__label')) {
      var label = document.createElement('span');
      label.className = 'cz-need-size__label';
      label.textContent = LABEL;
      btn.appendChild(label);
    }
    var hint = document.createElement('p');
    hint.className = 'cz-need-size__hint';
    hint.setAttribute('role', 'alert');
    hint.hidden = true;
    hint.textContent = HINT;
    fieldset.appendChild(hint);

    var done = false;
    function chosen() {
      if (done) return;
      done = true;
      form.classList.remove('cz-need-size');
      document.documentElement.classList.remove('cz-need-size-page');
      hint.hidden = true;
      // 3 Nov 2026 (audit F20): the hidden "Select a size" label stayed in the button, so screen readers kept
      // announcing it with the price. Gone once a size is chosen (it is never needed again on this page).
      [].forEach.call(document.querySelectorAll('.cz-need-size__label'), function (l) {
        if (!l.closest('quick-view-modal')) l.remove();
      });
      document.dispatchEvent(new CustomEvent('cz:size-chosen'));
    }
    radios.forEach(function (r) { r.addEventListener('change', chosen, { once: true }); });

    function block(e) {
      if (!form.classList.contains('cz-need-size')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      hint.hidden = false;
      fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var first = fieldset.querySelector('input[type=radio]:not(:disabled)') || radios[0];
      if (first) first.focus({ preventScroll: true });
    }
    form.addEventListener('submit', block, true);
    if (btn) btn.addEventListener('click', block, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
